(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/carousel/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/lb-ui/carousel/assets/javascripts/init.js');
"use strict";


const CarouselManager = svs.components.lbUi.carousel.CarouselManager;
const init = element => {
  const root = element || document;
  const carousels = [];
  let beforeUnloadAdded = false;
  const onBeforeUnload = () => {
    while (carousels.length) {
      carousels.pop().destroy();
    }
  };
  const initElement = el => {
    var _svs;
    if (!el || el.nodeType !== 1) {
      return;
    }
    const initialized = el.dataset.initialized;
    const _ref = ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.pix_mix) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 ? void 0 : _svs.carouselData) || {},
      align = _ref.align,
      cardSize = _ref.cardSize,
      gutter = _ref.gutter,
      itemsPerPage = _ref.itemsPerPage;
    if (!initialized) {
      carousels.push(new CarouselManager(el, {
        align,
        cardSize,
        gutter,
        itemsPerPage
      }));
      el.dataset.initialized = 'true';
      if (!beforeUnloadAdded) {
        window.addEventListener('beforeunload', onBeforeUnload);
        beforeUnloadAdded = true;
      }
    }
  };

  [...root.getElementsByClassName('js-carousel')].forEach(initElement);

  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => {
      if (m.type === 'childList') {
        m.addedNodes.forEach(node => {
          if (node.nodeType !== 1) {
            return;
          }
          if (node.classList && node.classList.contains('js-carousel')) {
            initElement(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('.js-carousel').forEach(initElement);
          }
        });
      } else if (m.type === 'attributes') {
        const target = m.target;
        if (target && target.classList && target.classList.contains('js-carousel')) {
          initElement(target);
        }
      }
    });
  });
  observer.observe(root, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'data-initialized']
  });

  return {
    destroy: () => {
      observer.disconnect();
      onBeforeUnload();
      if (beforeUnloadAdded) {
        window.removeEventListener('beforeunload', onBeforeUnload);
        beforeUnloadAdded = false;
      }
    }
  };
};
init(document);
setGlobal('svs.components.lbUi.carousel.init', init);

 })(window);